import {ApiResponseDto, VivoRootModel} from "@utils/Models";
import {getOneLoginUser} from "@utils/onelogin/OneLoginHelper";
import axios from "axios";
import {AuthenticationResponse} from "./auth.models";
import {ApiUrl_Login_ExchangeOneLoginToken, ApiUrl_Login_VerifyMember} from "@utils/Endpoints";
import {JwtUtils} from "./JwtUtils";
import {boolean} from "yup";

export default function useAuthenticationHelper() {
    /** checks if there is onelogin token. if not, returns null. Checks if the token is valid and obtains Vivo token along with RootModel.
     * saves the Vivo token and returns the root model or error message */
    async function validateOneLoginUserAsync(): Promise<VivoRootModel | string> {
        const user = await getOneLoginUser();
        if (!user)
            return "";
        //return "OneLogin token was invalid!";
        try {
            let response = await axios.post<ApiResponseDto<AuthenticationResponse>>(ApiUrl_Login_ExchangeOneLoginToken, user);
            let data = response.data.Result;
            JwtUtils.saveToken(data);
            return data.RootModel;
        } catch (error) {
            //@ts-ignore
            const errorMessage = error?.errorMessages?.[0] ?? error.message ?? error;
            //window.location.replace(`/en/access-denied`);
            return errorMessage;
            //return null;
        }
    }

    /** tries to use saved token to authorize connection to vivo portal backend. if it works (token is valid), returns fresh root model.
     * if it doesn't work, returns error message */
    async function validateUmbracoTokenAsync(): Promise<VivoRootModel | string> {
        try {
            let response = await axios.post<ApiResponseDto<VivoRootModel>>(ApiUrl_Login_VerifyMember);
            return response.data.Result;
        } catch (error : any) {
            //@ts-ignore
            if (error?.errorMessages?.length > 0) {
                //@ts-ignore
                return error?.errorMessages?.[0];
            }
            return error.message ?? "unknown error";
            
        }
    }

    return {
        validation: {
            validateOneLoginUserAsync,
            validateUmbracoTokenAsync
        }
    }
}